import { IOrderItems } from '~api/CartAPI/ICartApiSdk';

export interface IPGKitItem extends IOrderItems {
    CART_ID: number;
    CMS_THUMBNAIL_IMAGE: string;
    COLLECTION_ID: number;
    OFFER_CODE: string;
    'category.CATEGORY_NAME': string;
    formattedAppliedPrice: string;
    formattedUnitPrice: string;
    isCustomKitItem: number | null;
    isSampleItem: number;
    itemType: string;
    preOrderMsgShort: string;
    'prod.FAMILY_CODE': string;
    'prod.GIFTSET_COMPONENTS': string;
    'prod.IMAGE_STICKY': string;
    'prod.PARENT_CAT_ID': string;
    'prod.USES_SKU_IMAGES': string;
    'sku.HEX_VALUE': string;
    'sku.IMAGE_STICKY': string;
    'sku.INVENTORY_STATUS': number;
    'sku.PRODUCT_CODE': string;
    'sku.SKU_ID': string;
    'sku.THUMBNAIL_IMAGE': string;
    'sku.formattedInstallmentPrice': string;
    'sku.formattedPrice': string;
    'sku.isRefillable': number;
    'sku.SUPPRESS_IN_CART': boolean;
    IS_COLLECTION_DEFAULT_SKU: boolean;
    discountPercent: number;
    DISCOUNT_PCT: number;
    DISCOUNT_PRICE: number;
    DISCOUNT_AMOUNT: number;
    discountedAppliedPrice: number;
    basePrice: number;
}

export interface IPGKitItems {
    CART_ID: number;
    CART_QUANTITY: number;
    ITEM_QUANTITY: number;
    SKU_BASE_ID: number;
    COLLECTION_ID: number;
    COLLECTION_NAME: string;
    COLLECTION_QUANTITY: number;
    COLLECTION_SUBTYPE: string;
    COLLECTION_TYPE: string;
    basePrice: number;
    formattedAppliedPrice: string;
    formattedBundlePrice: string;
    formattedDiscountedAppliedPrice: string;
    formattedPrice: string;
    formattedUnitPrice: string;
    isCustomKitItem: number;
    itemForm: Record<string, unknown>;
    itemType: string;
    items: IPGKitItem[];
    'prod.ITEM_QUANTITY': number;
    'prod.PROD_RGN_NAME': string;
    'prod.PROD_RGN_SUBHEADING': string;
    'prod.THUMBNAIL_IMAGE': string;
    'prod.MEDIUM_IMAGE': string;
    'prod.SMALL_IMAGE': string;
    'prod.GIFTSET_COMPONENTS': string;
    'prod.url': string;
    rendered_cart_id: number;
    sku: number;
    'sku.IMAGE_MEDIUM': string;
    'sku.LARGE_IMAGE': string;
    'sku.MEDIUM_IMAGE': string;
    'sku.SMALL_IMAGE': string;
    'sku.SKU_BASE_ID': string;
    'sku.IMAGE_S': string;
    'sku.THUMBNAIL_IMAGE': string;
    'sku.REFILLABLE': number;
    'sku.isOutOfStock': number;
    'sku.isRefillable': number;
    'sku.PRODUCT_SIZE': string;
    'sku.SHADENAME': string;
    'sku.HEX_VALUE': string;
    'sku.HEX_VALUE_STRING': string;
    sku_string: string;
    ukitDiscountDetails: {
        discountedPrice: number;
        totalPercentage: number;
    };
    ukitCustomDetails: {
        title: string;
        image: string;
    };
    engraving?: {
        engraved_sku_id: string;
        engraved_sku: unknown;
        engraving_type: string;
        message: string[];
        templateId: number;
        templates: { [key: string]: number };
    };
    MONOGRAM_FONT?: string;
    MONOGRAM_TEXT?: string[];
    ENGRAVING_TYPE?: number;
    hasEngraving?: number;
    discountPercent: number;
    DISCOUNT_PCT: number;
    DISCOUNT_PRICE: number;
    DISCOUNT_AMOUNT: number;
    UNIT_PRICE: number;
    discountedAppliedPrice: number;
}

export enum IKitTypes {
    engraving = 'engraving',
    default = 'default',
    ukit = 'UKIT'
}

export interface IKitItem {
    type: string;
    subtype: string;
    name: string;
    shade: string;
    size: string;
    shadeCode: string;
    image: string | string[];
    skuId: string;
}

export interface IMappedKitItem {
    'prod.THUMBNAIL_IMAGE': string;
    'prod.MEDIUM_IMAGE': string;
    'prod.SMALL_IMAGE': string;
    'sku.IMAGE_MEDIUM': string;
    'sku.IMAGE_S': string;
    'sku.THUMBNAIL_IMAGE': string;
    'sku.LARGE_IMAGE': string;
    'sku.MEDIUM_IMAGE': string;
    'sku.SMALL_IMAGE': string;

    discountedAppliedPrice: number;
    UNIT_PRICE: number;
    DISCOUNT_AMOUNT: number;
    basePrice: number;
    DISCOUNT_PCT: number;
    discountPercent: number;
    DISCOUNT_PRICE: number;
    APPLIED_PRICE?: number;
    ITEM_QUANTITY?: number;
}
